import React, { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import CreateAnnouncements from "../../../features/adminDashboard/announcements/CreateAnnouncements";
import AnnouncementsList from "../../../features/adminDashboard/announcements/AnnouncementsList";

function Announcements() {
  const [activeTab, setActiveTab] = useState("list");
  const [editingAnnouncement, setEditingAnnouncement] = useState(null);

  const handleEdit = (announcement) => {
    setEditingAnnouncement(announcement);
    setActiveTab("create");
  };

  const handleCreateNew = () => {
    setEditingAnnouncement(null);
    setActiveTab("create");
  };

  const handleSuccess = () => {
    setEditingAnnouncement(null);
    setActiveTab("list");
  };

  const handleCancel = () => {
    setEditingAnnouncement(null);
    setActiveTab("list");
  };

  return (
    <Dashboard>
      <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
        <button
          onClick={() => setActiveTab("list")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "list"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          View Announcements
        </button>
        <button
          onClick={() => setActiveTab("create")}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            activeTab === "create"
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {editingAnnouncement ? "Edit Announcement" : "Create Announcement"}
        </button>
      </div>

      {activeTab === "list" ? (
        <AnnouncementsList onEdit={handleEdit} onCreateNew={handleCreateNew} />
      ) : (
        <div>
          {editingAnnouncement && (
            <button
              onClick={handleCancel}
              className="mb-4 px-4 py-2 text-sm bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
            >
              Cancel Edit
            </button>
          )}
          <CreateAnnouncements
            editingAnnouncement={editingAnnouncement}
            onSuccess={handleSuccess}
            onHandleCancel={handleCancel}
          />
        </div>
      )}
    </Dashboard>
  );
}

export default Announcements;
